import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

/**
 * Global auth callback handler for contractor portal magic links.
 * Processes auth tokens from URL hash and establishes session before any routes render.
 */
export function AuthCallbackHandler() {
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const handleAuthCallback = async () => {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const accessToken = hashParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token');

      if (accessToken && refreshToken) {
        console.log('🔐 Processing auth callback tokens...');
        setProcessing(true);
        
        try {
          // Set the session using the tokens from URL
          const { error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken
          });

          if (error) {
            console.error('❌ Failed to set session from callback:', error);
          } else {
            console.log('✅ Session established successfully');
            // Clean the URL to remove tokens
            window.history.replaceState({}, document.title, window.location.pathname);
          }
        } catch (error) {
          console.error('❌ Error processing auth callback:', error);
        } finally {
          setProcessing(false);
        }
      }
    };

    handleAuthCallback();
  }, []);

  // Show minimal loading indicator while processing
  if (processing) {
    return (
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Signing you in...</p>
        </div>
      </div>
    );
  }

  return null;
}
